import React from 'react';
import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconChevronDownDefault({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={25} height={24} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" fillRule="evenodd" d="M11.642 15.905a.75.75 0 0 0 1.06 0l6-6a.75.75 0 1 0-1.06-1.06l-5.47 5.47-5.47-5.47a.75.75 0 0 0-1.06 1.06z" clipRule="evenodd" /></svg></>;
}
export default IconChevronDownDefault;